"use strict";
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG_AUX_FUNCTIONS } from "../util/classes";
import { Whisper } from "../util/classes";
import { UTL } from "../util/classes";



export class DIALOG2 {
    // --- משתני רכיבים (Static Members) ---
    public static overlay_element: HTMLDivElement = null;  //     כי יש התייחסות מבחוץ public  זה חייב להיות
    private static popup_element: HTMLDivElement = null;
    private static caption_element: HTMLDivElement = null;
    private static input_element: HTMLInputElement = null;
    private static select_false_element: HTMLDivElement = null;
    private static select_true_element: HTMLDivElement = null;
    private static close_button_element: HTMLSpanElement = null;
    private static defo_button_element: HTMLSpanElement = null;
    private static panel_element: HTMLDivElement = null;
    private static ok_button_element: HTMLButtonElement = null;
    private static cancel_button_element: HTMLButtonElement = null;
    private static erase_button_element: HTMLButtonElement = null;

    // --- משתני מצב ---
    private static MD_FLAG: boolean = false;
    private static defo_button_is_clicked: boolean = false;
    private static Vamod_MouseX: number = 0;
    private static Vamod_MouseY: number = 0;
    private static Vamod_ModalWindowLeftX: number = 0;
    private static Vamod_ModalWindowTopY: number = 0;

    private static par_callback_function: Function = null;
    private static par_input_OBJ: oText | oMemo = null;
    private static par_wisper: Whisper = null;

    public static readonly BID = {
        UNDEFINED: 0,
        OK: 1,
        CANCEL: 2,
        ERASE: 3
    };

    private static var_current_pseudo_focused_btn: number = DIALOG2.BID.OK;

    // --- פונקציות בסדר המקורי ---

    private static refresh_pseudo_focus_for_all_buttons(): void {
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG2.ok_button_element, DIALOG2.var_current_pseudo_focused_btn == DIALOG2.BID.OK);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG2.cancel_button_element, DIALOG2.var_current_pseudo_focused_btn == DIALOG2.BID.CANCEL);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG2.erase_button_element, DIALOG2.var_current_pseudo_focused_btn == DIALOG2.BID.ERASE);
    }

    private static respond_tab(): void {
        DIALOG2.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Forward(DIALOG2.var_current_pseudo_focused_btn, DIALOG2.BID.OK, DIALOG2.BID.ERASE);
        DIALOG2.refresh_pseudo_focus_for_all_buttons();
    }

    private static respond_shift_tab(): void {
        DIALOG2.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Backward(DIALOG2.var_current_pseudo_focused_btn, DIALOG2.BID.OK, DIALOG2.BID.ERASE);
        DIALOG2.refresh_pseudo_focus_for_all_buttons();
    }

    private static create_overlay_element(): HTMLDivElement {
        const overlay_element = document.createElement("div");
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
        overlay_element.style.zIndex = "1000";
        return overlay_element;
    }

    private static create_popup_element(): HTMLDivElement {
        const popup_element = document.createElement("div");
        popup_element.id = "id-DIALOG2-popup";
        popup_element.style.position = "absolute";
        popup_element.style.backgroundColor = "#fff";
        popup_element.style.padding = "0px";
        popup_element.style.borderRadius = "8px";

        try {
            if (DIALOG2.par_wisper == Whisper.LONG_STRING_ALIGN_TO_RIGHT || DIALOG2.par_wisper == Whisper.LONG_STRING_ALIGN_TO_LEFT) {
                popup_element.style.width = "500px";
            }
            else {
                popup_element.style.width = "300px";
            }
        }
        catch (error) {
            alert(error);
        }

        popup_element.style.textAlign = "center";
        return popup_element;
    }

    private static create_caption_element(): HTMLDivElement {
        const caption = document.createElement("div");
        caption.textContent = "DIALOG2";
        caption.style.fontSize = "24px";
        caption.style.fontWeight = "bold";
        caption.style.margin = "0px";
        caption.style.padding = "0px";
        caption.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_caption_backgroundColor();
        caption.style.color = DIALOG_AUX_FUNCTIONS.get_caption_forgroundColor();
        caption.style.borderTopLeftRadius = "5px";
        caption.style.borderTopRightRadius = "5px";
        caption.style.userSelect = "none";
        return caption;
    }

    private static create_close_button(): HTMLSpanElement {
        const element = DIALOG_AUX_FUNCTIONS.create_close_button_element();
        return element;
    }

    private static create_defo_button(): HTMLSpanElement {
        const element = DIALOG_AUX_FUNCTIONS.create_defo_button_element();
        return element;
    }

    private static create_select_false_element(): HTMLDivElement {
        const element = document.createElement("div");
        element.style.backgroundColor = "green";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = "false";
        element.style.userSelect = "none";
        return element;
    }

    private static create_select_true_element(): HTMLDivElement {
        const element = document.createElement("div");
        element.style.backgroundColor = "green";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = "true";
        element.style.userSelect = "none";
        return element;
    }

    private static create_input_element(): HTMLInputElement {
        const element = document.createElement("input");
        element.id = "id-DIALOG2-input";
        element.style.width = "90%";
        if (DIALOG2.par_wisper == Whisper.ALIGN_LEFT || DIALOG2.par_wisper == Whisper.LONG_STRING_ALIGN_TO_LEFT)
            element.style.direction = "ltr";
        if (DIALOG2.par_wisper == Whisper.ALIGN_RIGHT || DIALOG2.par_wisper == Whisper.LONG_STRING_ALIGN_TO_RIGHT)
            element.style.direction = "rtl";
        element.type = "text";
        element.style.margin = "2px";
        element.style.fontSize = "24px";
        element.style.fontWeight = "bold";
        if (true) {
            element.placeholder = "";
        }

        element.style.border = "3px solid black";
        element.style.borderRadius = "6px";
        element.style.padding = "1px";
        element.style.outline = "none";

        if (DIALOG2.par_input_OBJ.OBJ_EXIST == false) {
            element.value = "";
        }
        if (DIALOG2.par_input_OBJ.OBJ_EXIST == true) {
            element.value = DIALOG2.par_input_OBJ.GetStr();
        }

        if (true) {
            const delay_in_miliseconds = 10;
            UTL.perform_focus_and_select_of_input_element_after_delay(element, delay_in_miliseconds);
        }

        return element;
    }

    private static create_panel_element(): HTMLDivElement {
        const buttonsContainer = document.createElement("div");
        buttonsContainer.style.marginTop = "15px";
        buttonsContainer.style.display = "flex";
        buttonsContainer.style.justifyContent = "space-around";
        buttonsContainer.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_panel_backgroundColor();
        buttonsContainer.style.marginBottom = "7px";
        return buttonsContainer;
    }

    private static create_ok_button_element(): HTMLButtonElement {
        const element = DIALOG_AUX_FUNCTIONS.create_ok_button_element();
        return element;
    }

    private static create_cancel_button_element(): HTMLButtonElement {
        const element = DIALOG_AUX_FUNCTIONS.create_cancel_button_element();
        return element;
    }

    private static create_erase_button_element(): HTMLButtonElement {
        const element = DIALOG_AUX_FUNCTIONS.create_erase_button_element();
        return element;
    }

    private static overlay_mousedown(event: MouseEvent): void {
        const target_element = event.target as HTMLElement;
        if (target_element == DIALOG2.caption_element) {
            const popup_element_bounding_rect = DIALOG2.popup_element.getBoundingClientRect();
            DIALOG2.MD_FLAG = true;
            DIALOG2.Vamod_MouseX = event.clientX;
            DIALOG2.Vamod_MouseY = event.clientY;
            DIALOG2.Vamod_ModalWindowLeftX = popup_element_bounding_rect.left;  //  אבל זאת כנראה היתה תקלה parsFloat במקור היה
            DIALOG2.Vamod_ModalWindowTopY = popup_element_bounding_rect.top;  //  אבל זאת כנראה היתה תקלה parsFloat במקור היה
        }
        if (target_element == DIALOG2.defo_button_element) {
            DIALOG2.defo_button_is_clicked = true;
        }
    }

    private static overlay_mousemove(event: MouseEvent): void {
        if (DIALOG2.MD_FLAG == true) {
            const delta_x = event.clientX - DIALOG2.Vamod_MouseX;
            const delta_y = event.clientY - DIALOG2.Vamod_MouseY;
            DIALOG2.popup_element.style.left = (DIALOG2.Vamod_ModalWindowLeftX + delta_x) + "px";
            DIALOG2.popup_element.style.top = (DIALOG2.Vamod_ModalWindowTopY + delta_y) + "px";
        }
    }

    private static overlay_mouseup(event: MouseEvent): void {
        const freezed_defo_button_is_clicked = DIALOG2.defo_button_is_clicked;
        DIALOG2.MD_FLAG = false;
        DIALOG2.defo_button_is_clicked = false;
        if (freezed_defo_button_is_clicked == false) {
            DIALOG2.input_element.focus();
        }
    }

    private static perform_pseudo_focused_button(): void {
        if (DIALOG2.var_current_pseudo_focused_btn == DIALOG2.BID.OK) {
            DIALOG2.perform_ok();
        }
        if (DIALOG2.var_current_pseudo_focused_btn == DIALOG2.BID.CANCEL) {
            DIALOG2.perform_cancel();
        }
        if (DIALOG2.var_current_pseudo_focused_btn == DIALOG2.BID.ERASE) {
            DIALOG2.perform_erase();
        }
    }

    private static overlay_keydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            DIALOG2.perform_pseudo_focused_button();
        }
        if (event.key === 'Escape') {
            DIALOG2.perform_cancel();
        }
        if (event.key === 'Tab') {
            event.preventDefault();
            if (event.shiftKey == false) DIALOG2.respond_tab();
            if (event.shiftKey == true) DIALOG2.respond_shift_tab();
        }
    }

    private static create_result_OBJ(p_value_exist: boolean, p_value_conent: string): oMemo | oText {
        if (DIALOG2.par_input_OBJ instanceof oText) return new oText(p_value_exist, p_value_conent);
        if (DIALOG2.par_input_OBJ instanceof oMemo) return new oMemo(p_value_exist, p_value_conent);
        alert("DIALOG2.error unknwon object");
    }

    private static call_callback(p_change_flag: boolean, p_value_exist: boolean, p_value_conent: string): void {
        if (DIALOG2.par_callback_function != null) {
            document.body.removeChild(DIALOG2.overlay_element);
            const delay_in_milliseconds = 0;
            let OBJ = DIALOG2.create_result_OBJ(p_value_exist, p_value_conent);

            if (true) {
                setTimeout(DIALOG2.par_callback_function, delay_in_milliseconds, p_change_flag, OBJ);
            }
            if (false) {
                DIALOG2.par_callback_function(p_change_flag, OBJ);
            }
            if (false) {
                setTimeout(() => {
                    DIALOG2.par_callback_function(p_change_flag, OBJ);
                }, 0);
            }
        }
        else {
            alert("DIALOG2_callback_function != null");
        }
    }

    private static perform_ok(): void {
        const change_flag = true;
        const value_exist = true;
        const value_content = DIALOG2.input_element.value;
        DIALOG2.call_callback(change_flag, value_exist, value_content);
    }

    private static perform_cancel(): void {
        const change_flag = false;
        const value_exist = false;
        const value_content = "";
        DIALOG2.call_callback(change_flag, value_exist, value_content);
    }

    private static perform_defo(): void {
        UTL.show_which_element_has_focus();
    }

    private static perform_erase(): void {
        const change_flag = true;
        const value_exist = false;
        const value_content = "";
        DIALOG2.call_callback(change_flag, value_exist, value_content);
    }

    private static create_new_br_element(): HTMLBRElement {
        const new_br_element = document.createElement('br');
        return new_br_element;
    }

    private static paint_colors_in_select_elements(element: HTMLElement, bval: boolean): void {
        if (bval == false) {
            element.style.backgroundColor = "white";
            element.style.color = "black";
        }
        if (bval == true) {
            element.style.backgroundColor = "blue";
            element.style.color = "white";
        }
    }

    public static create_dialog(p_callback_function: Function, p_input_OBJ: oMemo | oText, p_wisper: Whisper): void {
        DIALOG2.par_callback_function = p_callback_function;
        DIALOG2.par_input_OBJ = p_input_OBJ;
        DIALOG2.par_wisper = p_wisper;

        DIALOG2.overlay_element = DIALOG2.create_overlay_element();
        DIALOG2.popup_element = DIALOG2.create_popup_element();
        DIALOG2.caption_element = DIALOG2.create_caption_element();
        DIALOG2.close_button_element = DIALOG2.create_close_button();
        DIALOG2.defo_button_element = DIALOG2.create_defo_button();

        DIALOG2.select_false_element = DIALOG2.create_select_false_element();
        DIALOG2.select_true_element = DIALOG2.create_select_true_element();

        DIALOG2.input_element = DIALOG2.create_input_element();

        DIALOG2.panel_element = DIALOG2.create_panel_element();
        DIALOG2.ok_button_element = DIALOG2.create_ok_button_element();
        DIALOG2.cancel_button_element = DIALOG2.create_cancel_button_element();
        DIALOG2.erase_button_element = DIALOG2.create_erase_button_element();

        DIALOG2.overlay_element.appendChild(DIALOG2.popup_element);
        DIALOG2.caption_element.appendChild(DIALOG2.close_button_element);
        DIALOG2.caption_element.appendChild(DIALOG2.defo_button_element);
        DIALOG2.popup_element.appendChild(DIALOG2.caption_element);
        DIALOG2.popup_element.appendChild(DIALOG2.create_new_br_element());
        DIALOG2.popup_element.appendChild(DIALOG2.create_new_br_element());
        DIALOG2.popup_element.appendChild(DIALOG2.input_element);

        DIALOG2.popup_element.appendChild(DIALOG2.panel_element);
        DIALOG2.panel_element.appendChild(DIALOG2.ok_button_element);
        DIALOG2.panel_element.appendChild(DIALOG2.cancel_button_element);
        DIALOG2.panel_element.appendChild(DIALOG2.erase_button_element);

        DIALOG2.overlay_element.addEventListener("mousedown", DIALOG2.overlay_mousedown);
        DIALOG2.overlay_element.addEventListener("mousemove", DIALOG2.overlay_mousemove);
        DIALOG2.overlay_element.addEventListener("mouseup", DIALOG2.overlay_mouseup);
        DIALOG2.overlay_element.addEventListener("keydown", DIALOG2.overlay_keydown);
        DIALOG2.defo_button_element.addEventListener("click", DIALOG2.perform_defo);
        DIALOG2.ok_button_element.addEventListener("click", DIALOG2.perform_ok);
        DIALOG2.cancel_button_element.addEventListener("click", DIALOG2.perform_cancel);
        DIALOG2.erase_button_element.addEventListener("click", DIALOG2.perform_erase);
        DIALOG2.close_button_element.addEventListener("click", DIALOG2.perform_cancel);

        document.body.appendChild(DIALOG2.overlay_element);
        UTL.center_popup_element_inside_overlay_element(DIALOG2.popup_element, DIALOG2.overlay_element);
        DIALOG2.var_current_pseudo_focused_btn = DIALOG2.BID.OK;
        DIALOG2.refresh_pseudo_focus_for_all_buttons();
        DIALOG2.input_element.focus();
    }
}

